"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesiredCDPState = exports.MarketParams = exports.VaultInfo = void 0;
const utils_1 = require("./utils");
class MarketParams {
    constructor(constr) {
        this.oraclePrice = utils_1.ensureBigNumber(constr.oraclePrice);
        this.marketPrice = utils_1.ensureBigNumber(constr.marketPrice);
        this.FF = utils_1.ensureBigNumber(constr.FF);
        this.OF = utils_1.ensureBigNumber(constr.OF);
        this.slippage = utils_1.ensureBigNumber(constr.slippage);
    }
}
exports.MarketParams = MarketParams;
class VaultInfoBase {
    constructor(_debt, _coll) {
        this.currentDebt = utils_1.ensureBigNumber(_debt);
        this.currentCollateral = utils_1.ensureBigNumber(_coll);
    }
}
class VaultInfo extends VaultInfoBase {
    constructor(_debt, _coll, _minCollRatio) {
        super(_debt, _coll);
        this.minCollRatio = utils_1.ensureBigNumber(_minCollRatio);
    }
}
exports.VaultInfo = VaultInfo;
class DesiredCDPState {
    constructor(_reqRatio, _providedColl, _providedDai, _withdrawDai, _withdrawColl) {
        this.providedCollateral = utils_1.ensureBigNumber(_providedColl);
        this.requiredCollRatio = utils_1.ensureBigNumber(_reqRatio);
        this.providedDai = utils_1.ensureBigNumber(_providedDai);
        this.withdrawColl = utils_1.ensureBigNumber(_withdrawColl);
        this.withdrawDai = utils_1.ensureBigNumber(_withdrawDai);
    }
}
exports.DesiredCDPState = DesiredCDPState;
//# sourceMappingURL=types.js.map